import {createContext} from "react";
import {Answer, ImageHint} from "../types/types";

export type AppContextOpts = {
	searchPlaceHolder: string
	resultTitleWin: (guesses: number) => string
	resultTitleLose: () => string
	resultCopyHeader: (num: number) => string
	resultCopyFooter: string
	images: ImageHint[]
	answers: Answer[]
	countdownLabel: string
	title: string,
	donateLink: string
	blurSteps?: number[]
	domain?: string
}

export type IAppContext = AppContextOpts

export const AppContext = createContext<IAppContext>({
	searchPlaceHolder: 'Search answers',
	resultTitleWin: () => 'You Win',
	resultTitleLose: () =>'You Lose',
	countdownLabel: 'Next:',
	resultCopyHeader: (n: number) => {
		return `Number ${n}`
	},
	donateLink: '',
	resultCopyFooter: '',
	images: [],
	answers: [],
	blurSteps: [],
	title: ''
})

export const AppContextProvider = () => {

}

